(() => {
  const focusSuccess = (root) => {
    const message = root.querySelector('[data-contact-success]')
    if (!message) return
    const focus = () => requestAnimationFrame(() => {
      const active = document.activeElement
      if (active !== document.body && active !== message && active !== message.closest('form')) return
      message.focus({ preventScroll: true })
      message.scrollIntoView({ block: 'center', behavior: 'instant' })
    })
    if (document.readyState === 'complete') {
      focus()
    } else {
      window.addEventListener('load', focus, { once: true })
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => focusSuccess(document), { once: true })
  } else {
    focusSuccess(document)
  }

  document.addEventListener('shopify:section:load', (event) => focusSuccess(event.target))
})()
